<template lang="html">
    <div class="body">

        <header>
            <div class="container-fluid bg-white mb-5">
                <div class="container pl-1 pt-3 pb-3">
                    <a href="https://www.jmirpublications.com" target="_blank">
                        <img style="width: 255px;" src="/public/images/JMIR-logo@2x.png">
                    </a>
                </div>
            </div>
        </header>

        <div v-if="step != 4" class="container custom-container">
            <div class="row">

                <div class="side-bar col-md-2 pl-0 pr-0">
                    <div>

                        <p v-bind:class="{
                            'numb-text-active': step == 1,
                            'numb-text-done': step > 1,
                            'numb-text-next': step < 1
                            }">
                            <span class="numb"
                            v-bind:class="{
                                'numb-blue': step == 1,
                                'numb-green': step > 1,
                                'numb-grey': step < 1
                            }">
                                <span v-if="step == 1">1</span>
                                <span v-else>
                                    <i class="fa fa-check"
                                        style="font-size: 9px;">
                                    </i>
                                </span>
                            </span>
                            ORCID validation
                        </p>

                        <p v-bind:class="{
                            'numb-text-active': step == 2,
                            'numb-text-done': step > 2,
                            'numb-text-next': step < 2
                            }">
                            <span class="numb"
                            v-bind:class="{
                                'numb-blue': step == 2,
                                'numb-green': step > 2,
                                'numb-grey': step < 2
                            }">
                                <span v-if="step == 2 || step == 1">2</span>
                                <span v-else>
                                    <i class="fa fa-check"
                                        style="font-size: 9px;">
                                    </i>
                                </span>
                            </span>
                            Connect ORCID
                        </p>

                        <p v-bind:class="{
                            'numb-text-active': step == 3,
                            'numb-text-done': step > 3,
                            'numb-text-next': step < 3
                            }">
                            <span class="numb-last"
                            v-bind:class="{
                                'numb-blue': step == 3,
                                'numb-green': step > 3,
                                'numb-grey': step < 3
                            }">
                                <span v-if="step > 0">3</span>
                                <span v-else>
                                    <i class="fa fa-check"
                                        style="font-size: 9px;">
                                    </i>
                                </span>
                            </span>
                            Author information
                        </p>

                    </div>
                </div> <!-- .side-bar end -->

                <!-- main -->
                <div class="col-md-10 pl-0 pr-0">

                    <!-- title -->
                    <div v-if="article"
                        class="col-md-12 pl-0 pr-0 mb-4">
                        <b>Title:</b>
                        <small>{{ article.title }}</small>
                    </div>
                    <!-- title end -->

                    <div class="panel">

                        <div class="panel__header">
                            <h1 class="panel__title">
                                <span v-if="step == 1">ORCID validation</span>
                                <span v-if="step == 2">Connect ORCID</span>
                                <span v-if="step == 3">Review author information</span>
                            </h1>
                        </div>

                        <div class="panel__body">

                            <div v-if="step == 1">

                                <div v-if="orcid && user && orcid.orcid != user.orcid">
                                    <div class="panel__body_main">
                                        <h2 class="text-center mb-5">We have found multiple ORCID accounts, please select one that you
                                            want to validate and connect with JMIR.
                                        </h2>

                                        <div>
                                            <a
                                                class="link-multiple-orcid"
                                                href="javascript:;"
                                                v-on:click="selectOrcid(orcid.orcid)">

                                                <div class="multiple-orcid d-flex mb-2">
                                                    <div class="mr-auto">
                                                        <b>Name: {{ orcid.name }} <small v-if="orcid.orcid == selectedOrcid">(current)</small></b>
                                                        <br>
                                                        <img
                                                            style="width:18px; margin-right:3px;"
                                                            src="https://asset.jmir.pub/assets/static/images/orcidGreen.svg"
                                                        >
                                                        <b>{{ orcid.orcid }}</b>
                                                    </div>

                                                    <div class="mt12">
                                                        <i class="fa fa-chevron-right text-right"></i>
                                                    </div>
                                                </div>

                                            </a>
                                        </div>

                                        <div>
                                            <a class="link-multiple-orcid"
                                                href="javascript:;"
                                                v-on:click="selectOrcid(user.orcid.orcid)">

                                                <div class="multiple-orcid d-flex mb-2">
                                                    <div class="mr-auto">
                                                        <b>Name:
                                                        <span>{{ user.first_name }}</span>
                                                        <span>{{ user.last_name }}</span>
                                                        <small v-if="user.orcid.orcid == selectedOrcid">(current)</small>
                                                        </b>
                                                        <br>
                                                        <img
                                                            style="width:18px; margin-right:3px;"
                                                            src="https://asset.jmir.pub/assets/static/images/orcidGreen.svg"
                                                        >
                                                        <b>{{ user.orcid.orcid }}</b>
                                                    </div>
                                                    <div class="mt12">
                                                        <i class="fa fa-chevron-right text-right"></i>
                                                    </div>
                                                </div>

                                            </a>
                                        </div>

                                    </div>
                                </div>

                                <div v-else>
                                    <div class="panel__body_main text-center">
                                        <i class="fa fa-check green-checkmark"></i>
                                        <h2>Validation successful!</h2>
                                        <p>Thank you for validating your ORCID</p>
                                        <img
                                            style="width:18px; margin-right:3px;"
                                            src="https://asset.jmir.pub/assets/static/images/orcidGreen.svg"
                                        >

                                        <b v-if="orcid">{{ orcid.orcid }}</b>
                                        <span style="color: #9d9d9d;">| </span><b>Name: {{ orcid.name }}</b></span>
                                    </div>

                                    <div class="panel__body_footer">
                                        <b>Note:</b>
                                        <br>
                                        <small>If this ORCID does nor belong to you, it is possible that another user is logged in to ORCID on your browser. Please go to <a href="https://orcid.org/" target="_blank">www.orcid.org</a>, logout, and click the validation link in the email again.</small>
                                    </div>
                                </div>

                            </div> <!-- step 1 end -->

                            <div v-if="step == 2">

                                <div v-if="!user">
                                    <div class="panel__body_main text-center">
                                        <h2>Connect ORCID to JMIR Account (optional)</h2>
                                        <p>If you connect your validated ORCID to your JMIR account, you can skip the authentication step for future submissions.</p>
                                        <div class="container mt-5">
                                            <div class="row justify-content-center">

                                                <div class="col-md-4 text-center bg-light-blue mb-2 margin-box-1">
                                                    <b class="fs">Already have an account?</b>
                                                    <br>
                                                    <br>
                                                    <a
                                                        v-bind:href="'https://accounts.jmir.pub?redirectTo=' + url"
                                                        class="btn-custom btn-custom-blue mt-4"
                                                        style="padding: 10px;"
                                                        >
                                                        Sign into JMIR
                                                    </a>
                                                </div>

                                                <div class="col-md-4 text-center bg-light-blue mb-2 margin-box-2">
                                                    <b class="fs">Don't have an account?</b>
                                                    <br>
                                                    <br>
                                                    <a
                                                        v-bind:href="'https://accounts.jmir.pub/register?redirectTo=' + url"
                                                        class="btn-custom btn-custom-blue mt-4"
                                                        style="padding: 10px;"
                                                        >
                                                        Create JMIR account
                                                    </a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="panel__body_main text-center">
                                        <i class="fa fa-check green-checkmark mb-3"></i>
                                        <h2>Your ORCID is successfully connected to JMIR Account</h2>
                                        <p>Continue to review author information</p>
                                    </div>
                                </div>

                            </div> <!-- step 2 end -->

                            <div v-if="step == 3">

                                <author
                                    v-bind:article="article"
                                    v-bind:author="author"
                                    v-bind:index="index"
                                />

                            </div> <!-- step 3 end -->

                        </div>

                    </div> <!-- .panel end -->

                </div> <!-- main end -->

                <!-- buttons -->
                <div class="container mt-4 d-flex justify-content-end"
                    style="padding-right: 0px !important;">

                    <button
                        v-if="step > 1"
                        v-on:click="previous"
                        href="javascript:;"
                        class="btn-custom btn-custom-grey mr-2">
                            <i class="fas fa-chevron-left mr-2"></i>
                            Go back
                    </button>

                    <button
                        v-if="step != 3"
                        v-on:click="next"
                        href="javascript:;"
                        class="btn-custom btn-custom-blue"
                        >
                            Continue
                            <i class="fas fa-chevron-right ml-2"></i>
                    </button>

                    <button
                        v-if="step == 3"
                        v-on:click="next"
                        href="javascript:;"
                        class="btn-custom btn-custom-blue">
                            Finish
                            <i class="fas fa-chevron-right ml-2"></i>
                    </button>

                </div> <!-- buttons end -->

            </div> <!-- .row end -->
        </div> <!-- .container .custom-container end -->

        <!-- ORCID validated and author detaols reviewed -->
        <div v-if="step == 4" class="container custom-container">
            <div class="panel__body_main text-center">
                <i class="fa fa-check green-checkmark mb-3"></i>
                <h2 class="pl-5 pr-5">Thank you for validating your ORCID and
                <br>reviewing your author details!</h2>
                <br>
                <button href="#" class="btn-custom btn-custom-blue">Explore our journals</button>
            </div>
        </div>
        <!-- ORCID validated and author detaols reviewed end -->

    </div> <!-- .body end -->
</template>

<script>
export default {
    props: ["authorId", "articleId", "user", "orcid", "url"],
    data: {
        step: null,
        article: null,
        author: null,
        orcid: null,
        selectedOrcid: null,
    },
    methods: {
        selectOrcid: function(orcid) {
            let vm = this;

            vm.selectedOrcid = orcid;

            vm.$forceUpdate();
        },
        previous: function() {
            let vm = this;

            vm.step--;

            if (typeof localStorage !== "undefined") {
                localStorage.setItem("step", vm.step);
            }

            vm.$forceUpdate();
        },
        next: function() {
            var vm = this;

            vm.step++;


            if (typeof localStorage !== "undefined") {
                localStorage.setItem("step", vm.step);
            }

            vm.$forceUpdate();
        }
    },
    async created() {
        let vm = this;

        vm.step = localStorage.step || 1;

        await axios
            .get("/api/article-authors/" + vm.articleId + "/" + vm.authorId)
            .then(function(response) {
                vm.orcid = JSON.parse(response.data.verified_object);
                vm.author = response.data;
                vm.article = response.data.article;

                vm.selectedOrcid = vm.user.orcid.orcid;

                delete vm.author.article;
                delete vm.article.authors;

                vm.$forceUpdate();
            });
    },
    updated() {
        updateIFrameHeight();
    }
};
</script>

<style lang="css" scoped>

button:disabled,
button[disabled] {
  cursor: not-allowed;
}

/* .btn-custom-blue {
    text-decoration: none;
    color: white;
} */

.btn-custom-blue:hover {
    text-decoration: none;
    color: white;
}

.mt12 {
  margin-top: 12px;
}

.green-checkmark {
  color: #fff;
  background-color: #629f36;
  border-radius: 50%;
  padding: 13px;
  font-size: 28px;
}

.link-multiple-orcid {
  color: black;
  display: block;
  max-width: fit-content;
  margin: auto;
}

.link-multiple-orcid:hover {
  color: black;
  text-decoration: none;
}

.link-multiple-orcid:focus {
  background-color: #f0efef;
}

.multiple-orcid {
  border: 1px solid #e7e7e7;
  width: 350px;
  padding: 7px 15px 7px 15px;
  margin: auto;
}

.multiple-orcid:hover {
  background-color: #f0efef;
}

.body {
  background-color: #e7e7e7;
}

.custom-container {
  background-color: #fff;
  padding: 40px;
  border: 1px solid #dddddd;
}

/* numb main */
.numb,
.numb-green,
.numb-blue,
.numb-last {
  padding: 2px 6px;
  border-radius: 50%;
  position: relative;
}

.numb.numb-green::after {
  content: "";
  position: absolute;
  left: 45%;
  top: 100%;
  width: 2px;
  height: 0;
  margin-top: 2px;
  border-top: 11px solid #629f36;
}

.numb.numb-blue::after {
  content: "";
  position: absolute;
  left: 45%;
  top: 100%;
  width: 2px;
  height: 0;
  margin-top: 2px;
  border-top: 11px solid #e8e8e8;
}

.numb.numb-grey::after {
  content: "";
  position: absolute;
  left: 45%;
  top: 100%;
  width: 2px;
  height: 0;
  margin-top: 2px;
  border-top: 11px solid #e8e8e8;
}

/* circled numbers */
.numb-green {
  background-color: #629f36;
  color: #fff;
}

.numb-blue {
  background-color: #207db4;
  color: #fff;
}

.numb-grey {
  background-color: #f0efef;
  color: #909090;
}

/* text */
.numb-text-active {
  color: #207db4;
}

.numb-text-done {
  color: #000;
}

.numb-text-next {
  color: #b2b2b2;
}

.bg-light-blue {
  background-color: #e8f2f7;
  padding-top: 50px;
  padding-bottom: 50px;
}

.fs {
  font-size: 16px;
}

.margin-box-1 {
  margin-right: 20px;
}

.margin-box-2 {
  margin-left: 20px;
}

@media only screen and (max-width: 767px) {
  .margin-box-1 {
    margin-right: 0px;
  }

  .margin-box-2 {
    margin-left: 0px;
  }
}
</style>
